import styled from 'styled-components/macro';

export const Container = styled.div`
    height: 100%;
`;

export const ModuleWrapper = styled.div`
    height: 100%;
`;
